// NymblStudio DOM-inspector loader (Nymbl App Spec §2.9, SHOULD).
//
// When this app runs in dev INSIDE the studio's Build → App iframe, the studio
// can't reach our DOM (cross-origin). This loader waits for the studio's init
// handshake and then injects the studio-served inspector bridge script, which
// does the actual element highlighting/picking and reports back via
// postMessage. Dev-only — compiled out of production builds — and inert when
// the page isn't iframed.

function isInitMessage(data: unknown): boolean {
  return (
    typeof data === "object" &&
    data !== null &&
    "type" in data &&
    data.type === "nymbl-inspector:init"
  );
}

// Security boundary: only the studio may trigger script injection. Local dev
// pairs localhost:8080 (studio) with localhost:<port> (app); on workstations
// the app at <project>.<workstation>.nymbl.studio accepts only its parent
// domain <workstation>.nymbl.studio. Everything else is silently ignored.
function isTrustedStudioOrigin(origin: string): boolean {
  let host: string;
  try {
    host = new URL(origin).hostname;
  } catch {
    return false;
  }
  if (host === "localhost" || host === "127.0.0.1") return true;
  return window.location.hostname.endsWith(`.${host}`);
}

// Guard `process` — browser preview has no Node process global.
const isDev = typeof process !== "undefined" ? process.env.NODE_ENV !== "production" : true;

if (isDev && typeof window !== "undefined" && window.self !== window.top) {
  let injected = false;
  window.addEventListener("message", (event: MessageEvent) => {
    if (injected) return;
    if (!isInitMessage(event.data)) return;
    if (!isTrustedStudioOrigin(event.origin)) return;
    injected = true;
    const script = document.createElement("script");
    script.src = `${event.origin}/inspector-bridge.js`;
    document.head.appendChild(script);
  });
}
